import { useQuery } from "@tanstack/react-query";
import { getReceiptConfig } from "apis";

const useGetReceiptConfig = ({
  doctor_oid,
  clinic_id,
}: {
  doctor_oid: string;
  clinic_id: string;
}) => {
  return useQuery(
    [`get-receipt-${doctor_oid}-${clinic_id}`],
    () =>
      getReceiptConfig({
        doctor_oid,
        clinic_id,
      }),
    {
      enabled: !!doctor_oid && !!clinic_id,
    }
  );
};

export default useGetReceiptConfig;
